"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStepInError = exports.isStepComplete = void 0;
exports.isStepComplete = (status) => status === 'complete';
exports.isStepInError = (status) => status === 'error';
